// extracted by mini-css-extract-plugin
module.exports = {"border-radius":"10px"};